export default {
    clinicSonographyTitle: "Follicle Tracking",
    indication: "indication",
    examinationMethod: "examinationMethod",
    examinationView: "examinationView",
    leftOvaryMM1: 'left Ovary MM1',
    rightOvaryMM1: 'right Ovary MM1',
    uterusPosition: "uterus Position",
    uterusSize: "uterusSize",
    endometriumIsoTest: "endometriumIsoTest",
    tripleLinePattern: "tripleLinePattern",
    eT: 'eT',
    distanceFromExternalCervicalOsToFundus: 'distanceFromExternalCervicalOsToFundus',
    distanceFromExternalCervicalOsToEndometrium: 'distanceFromExternalCervicalOsToEndometrium',
    threeDCoronalView: "threeDCoronalView",
    threeDCoronal: "threeDCoronal",
    uterineArteryPulsatilityIndexDoppler: 'uterineArteryPulsatilityIndexDoppler'
}